import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth/auth.service';

export type Theme = 'borger.dk' | 'virk.dk' | 'neutral';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  themeCss$ = new BehaviorSubject<string>('neutral');

  private theme: Theme = 'neutral';
  private referrerKey = 'ReferrerKey';

  constructor(private authService: AuthService, private route: ActivatedRoute) {}

  initialize() {
    this.authService.userInfo$.subscribe(userInfo => {
      if (userInfo) {
        if (userInfo.isEmployee) {
          this.setSessionReferrer('virk.dk');
        } else {
          if (this.getSessionReferrer() === 'borger.dk') {
            this.setTheme('borger.dk');
          } else {
            this.setSessionReferrer('neutral');
          }
        }
      }
    });

    this.route.queryParams.subscribe(params => {
      if (params['ref'] === 'virk') {
        this.setSessionReferrer('virk.dk');
        if (!this.authService.user) {
          this.authService.login('', true);
        }
      }
    });
  }

  getThemes(): Theme[] {
    return ['neutral', 'borger.dk', 'virk.dk'];
  }

  setTheme(theme: Theme) {
    this.theme = theme;

    switch (this.theme) {
      case 'borger.dk':
        this.themeCss$.next('borgerdk');
        break;
      case 'virk.dk':
        this.themeCss$.next('virkdk');
        break;
      case 'neutral':
      default:
        this.themeCss$.next('neutral');
        break;
    }
  }

  setThemefromReferrer(referrer: string) {
    if (referrer) {
      const themeFound = this.getThemes().find(theme => {
        return this.urlMatchHost(referrer, theme);
      });

      this.setSessionReferrer(themeFound ? themeFound : 'neutral');
    } else {
      this.setThemeFromSession();
    }
  }

  setThemeFromSession() {
    const themeFound = this.getThemes().find(theme => {
      return this.getSessionReferrer() === theme;
    });
    if (themeFound) {
      this.setTheme(themeFound);
    }
  }

  urlMatchHost(url: string, host: Theme): boolean {
    if (URL) {
      return new URL(url).hostname.includes(host);
    } else {
      // IE 11 compatibility
      return url.includes(host);
    }
  }

  setSessionReferrer(theme: Theme) {
    if (sessionStorage) {
      sessionStorage.setItem(this.referrerKey, theme);
    }
    this.setTheme(theme);
  }

  getSessionReferrer(): string {
    let referrer = '';
    if (sessionStorage) {
      referrer = sessionStorage.getItem(this.referrerKey);
    }
    return referrer;
  }
}
